/**
 * Unique id for a client-created chat message.
 *
 * `bot_${Date.now()}` is NOT unique: ChatService parses one network chunk into
 * several SSE events and dispatches them synchronously, so an ORDER_CREATED
 * frame and the continuation behind it opened two placeholders in the same
 * millisecond — two messages with ONE id. Every later frame was then applied
 * to both (the stream updates "the message whose id is current"), the
 * annotated-image assignment (keyed by id) gave the marked photo to both, and
 * React rendered two siblings under one key: the "VIN … confirmed" bubble and
 * its photo shown twice, flickering, gone after the next history reload
 * (live 2026-10-11).
 */
let seq = 0;

export function newMessageId(prefix: string): string {
  seq = (seq + 1) % 1_000_000;
  const rand = Math.random().toString(36).slice(2, 8);
  return `${prefix}_${Date.now()}_${seq}_${rand}`;
}
